import axios from 'axios';
import config from '@/configs';

const state = {
    token: '',
    user: {},
    resData: {},
};

const getters = {};

const actions = {
  login({ commit }, loginInfo) {
    axios.post(`${config.API}/api-token-auth/`, loginInfo).then((response) => commit('setToken', response.data)).catch((error) => console.log(error))
  }
};

const mutations = {
  clearToken(state) {
    state.token = '';
    state.user = {};
    localStorage.clear();
    setTimeout(() => window.getApp.$router.replace('/dang-nhap'), 100);
  },
  setToken(state, data) {
    state.resData = data;
    if(data.status_code == 400){
        return;
    }

    state.token = data.token;
    state.user = data.user;
    localStorage.setItem('jwt', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
    setTimeout(() => window.getApp.$router.replace('/'), 100);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
